// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__alomni_f77b04', '__alomni_Fallback_f77b04'"},"className":"__className_f77b04","variable":"__variable_f77b04"};